import {
  GET_BOOK,
  GET_BOOKS,
  SET_ALL_BOOKS,
  SET_ALL_BOOKS_SELECT,
  CREATE_BOOK,
  UPDATE_BOOK,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const bookReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_BOOKS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_BOOKS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_BOOKS_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
          labelEn: `${data.titleEn}`,
          price: data.price,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_BOOK:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_BOOK:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_BOOK:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default bookReducer;
